export default __webpack_public_path__ + "static/krasnoyarsk_main-a19db76726c34a02c2ad07a32dbafa06.jpg";